import { Component, OnInit, Inject, Input, SimpleChanges, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA, MatMenuTrigger } from '@angular/material';
import { StaffService } from '../../services/staff/staff.service';
import { FormBuilder, FormControl, FormArray, Validators, FormGroup, Validator } from '@angular/forms';
import { DeleteConfirmModalComponent } from '../../commons/delete-confirm-modal/delete-confirm-modal.component'
import * as _ from 'lodash';
import { usersFields, userRolesList, select, licenseCategory, reporterForm, accidentUserRoles, payTypes, payMethods } from '../../_models/staticArray'
import { Observable } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { EncryptDecryptService } from '../../services/encrypt-decrypt.service';
import { AccidentUserService } from '../../services/accident-user.service'
import { AccidentService } from '../../services/accident.service';
import { AssetService } from '../../services/asset.service';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import { UtilityService } from 'src/app/services/utility.service';
import { PolicyService } from '../../services/policy.service'
declare var $;
declare var what3words: any;



export interface Instructor {
  _id: string;
  name: string;
  dateOfJoining: Date;
  email: string;
  password: string;
};


@Component({
  selector: 'app-edit-staff-modal',
  templateUrl: './edit-staff-modal.component.html',
  styleUrls: ['./edit-staff-modal.component.scss']
})

export class EditStaffModalComponent implements OnInit {

  @Input('instructor') staffData
  @Output() updatedInstructor: EventEmitter<any> = new EventEmitter();
  loading: Boolean = false;
  instructorData;
  editStaffForm
  passwordMismatch: boolean;
  isDisableInstructor: boolean
  currentUser: any;
  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter();

  accidentRole = accidentUserRoles
  reporterForm = reporterForm
  previousIndex
  certFile: any = [];
  show: boolean;
  pwd: boolean;
  show1: boolean;
  pwd1: boolean;
  url1: any;
  profileFile: any = [];
  url;
  error: any;
  data: any;
  instructorMpJobs = [];
  instructorTrainerJobs = [];
  isMpJob = false;
  isTrainerJob = false;
  deleteError: boolean = false
  deleteErrorMsg
  user
  disableValue = false
  module: any;
  editUserForm
  displayName
  isField: boolean = false
  accidentUser
  userRoleList = userRolesList
  userFields: any = usersFields
  userFieldsCopy = this.userFields
  select = select
  licenseCategories = licenseCategory
  userDocuments = []
  isConviction: any = false
  url2: any;
  newFiles: any = [];
  files: any = [];
  isUserRole: any = false
  isDisplay: boolean = false
  isAccident = false
  size: number;
  isDisable: boolean = false;
  isEdit: boolean = false;
  editAccidentDetails
  isAdmin: boolean = false;
  isPolicy: any = false
  latitude: number;
  longitude: number;
  address: any;
  isMapEdit
  what3words = {}
  sponsorpackDocs = []
  payType = payTypes
  payMethod = payMethods
  jobRoleList = []
  @ViewChild('clickMenuTrigger', { static: false })
  private readonly clickMenuTrigger: MatMenuTrigger;


  constructor(
    public _EncryptDecryptService: EncryptDecryptService,
    public dialog: MatDialog,
    private router: Router,
    public dialogRef: MatDialogRef<Instructor>,
    @Inject(MAT_DIALOG_DATA) public data1: any,
    public _staffService: StaffService,
    public formBuilder: FormBuilder,
    public _userAccident: AccidentUserService,
    private activatedRoute: ActivatedRoute,
    public _accidentService: AccidentService,
    public _assetService: AssetService,
    public _utilityService: UtilityService,
    public _policyService: PolicyService
  ) {
    // NO DEFINITION

  }


  ngOnInit() {

    this.loading = true
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    this.getJobRoleList()
    if (this.user.isAdmin) {
      console.log("this.isAdmin", this.user.isAdmin);
      this.isAdmin = true
    }
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));

    this.module = JSON.parse(localStorage.getItem('module'))
    console.log("value of login user details", this.user);
    if (this.user && this.user.isTrainer) {
      this.disableValue = true
    } else {
      this.disableValue = false
    }

    if (!this.user.isAdmin) {
      this.accidentRole = [
        { key: 'Witness', value: 'witness' }]
    }

    console.log("DATA = ", this.data1);
    this.size = Object.keys(this.data1).length;

    if (this.size != 0) {
      this.data = this.data1[0]
      console.log("what is get data from other page", this.data);
      this.instructorData = JSON.parse(JSON.stringify(this.data));
      this.isPolicy = this.instructorData.userId.passwordPolicy
      console.log("details of insctructor data", this.instructorData);
      let jobArray = []
      if (this.data1[1] && this.data1[1].jobs) {
        jobArray == this.data1[1].jobs
      } else {
        jobArray = this.data1[1]
      }

      console.log("DATA = ", this.data1);

      /**
       * codinal base check accident user or edit staff
       */
      if (this.data.accidentUser == true) {

        this.isDisableInstructor = false;
        if (this.data && this.data.accidentType == 'goodPractice') {
          // this.selectedRole = 'reporter'
          this.accidentRole = [
            { key: 'Reporters', value: 'reporter' }]
          this.isDisable = true
        }
        if (this.data.edit) {
          console.log("data1===>", this.data1)
          this.instructorData.password = this._EncryptDecryptService.decrypt(this.data.password)
          this.instructorData.confirmPassword = this._EncryptDecryptService.decrypt(this.data.password)
          // }
          this.displayName = 'Edit Incident User'
          if (this.data1 && this.data1.onModel && this.data1.onModel == 'accidentUser') {
            this.isField = false
          } else {
            this.isField = true
          }
          this.isDisplay = false
          this.createForm1(this.instructorData)
        } else {
          this.isDisplay = false
          this.createForm1()
          this.displayName = 'Add Incident User'
        }
        this.accidentUser = this.data.accidentUser;
        // this.editUserForm.get('accidentUserRole').
        this.editUserForm.controls.accidentUserRole.setValue('reporter');

      } else {
        this.displayName = 'Edit User'
        this.isDisableInstructor = true;
        // this.data = this.data1[0]
        console.log("what is get data from other page", this.data);
        // this.instructorData = JSON.parse(JSON.stringify(this.data));
        console.log("details of insctructor data", this.instructorData);
        let jobArray = []
        if (this.data1[1] && this.data1[1].jobs) {
          jobArray == this.data1[1].jobs
        } else {
          jobArray = this.data1[1]
        }

        jobArray.forEach((singleJob) => {
          if (singleJob.jobType == "trainer") {
            this.instructorTrainerJobs.push(singleJob.title)
          }
          else if (singleJob.jobType == "mp") {
            this.instructorMpJobs.push(singleJob.title)
          }
        });

        console.log(this.instructorTrainerJobs, this.instructorMpJobs);
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        console.log("current user value", this.currentUser);


        // this.instructorData.dateOfJoining = this.formatDate(this.instructorData.dateOfJoining);
        console.log("DATE = ", this.instructorData.dateOfJoining);

        this.instructorData.password = this._EncryptDecryptService.decrypt(this.instructorData.password)
        this.instructorData.confirmPassword = this.instructorData.password;
        // console.log('this accident role heree...',this.accidentRole)
        // let data={}
        // this.validate(data)
        this.isDisplay = true
        this.createForm(this.instructorData, 'test1')
        this.userFields = (this.instructorData && this.instructorData.details && this.instructorData.details.userFields) ? this.instructorData.details.userFields : this.userFieldsCopy
        let isConviction = this.userFields.find((x) => {
          if (x.status == 'isMotoring') {
            console.log("this is x to checkd", x);

            this.isConviction = x.checked
          }
          else {

            // return x.checked
          }
        })
        this.files = this.instructorData && this.instructorData.userFiles && this.instructorData.userFiles.length ? this.instructorData.userFiles : []
        this.sponsorpackDocs = this.instructorData && this.instructorData.userDocuments && this.instructorData.userDocuments.length ? this.instructorData.userDocuments : []
        this.isUserRole = this.instructorData && this.instructorData.userId.userRole && this.instructorData.userId.userRole.length ? true : false
        console.log("what is the value of this.isConviction", this.isConviction);
      }
      $("#password").click(function () {
        $("#password").toggleClass("fa-eye fa-eye-slash");
      });

      $("#cpassword").click(function () {
        $("#cpassword").toggleClass("fa-eye fa-eye-slash");
      });
    } else {
      this.createForm({}, 'test2')
      this.isDisplay = true
      this.isDisableInstructor = true;
    }


  }



  ngOnChanges(changes: SimpleChanges): void {
    $("#password").click(function () {
      $("#password").toggleClass("fa-eye fa-eye-slash");
    });

    $("#cpassword").click(function () {
      $("#cpassword").toggleClass("fa-eye fa-eye-slash");
    });
    console.log("changes of user role", changes);
    if (changes.staffData && changes.staffData.currentValue) {
      this.instructorData = changes.staffData.currentValue
      this.isPolicy = this.instructorData.userId.passwordPolicy
      this.userFields = []
      this.loading = false
      this.instructorData.password = this._EncryptDecryptService.decrypt(this.instructorData.password)
      this.instructorData.confirmPassword = this.instructorData.password;
      // this.instructorData.dateOfJoining = this.formatDate(this.instructorData.dateOfJoining);

      this.userFields = (this.instructorData && this.instructorData.details && this.instructorData.details.userFields) ? this.instructorData.details.userFields : this.userFieldsCopy
      let isConviction = this.userFields.find((x) => {
        if (x.status == 'isMotoring') {
          console.log("this is x to checkd", x);

          this.isConviction = x.checked
        }
        else {

          // return x.checked
        }
      })
      console.log("what is the value of this.isConviction", this.isConviction);
      this.files = this.instructorData && this.instructorData.userFiles && this.instructorData.userFiles.length ? this.instructorData.userFiles : []
      this.sponsorpackDocs = this.instructorData && this.instructorData.userDocuments && this.instructorData.userDocuments.length ? this.instructorData.userDocuments : []
      this.isUserRole = this.instructorData && this.instructorData.userId.userRole && this.instructorData.userId.userRole.length ? true : false
      console.log("user fields data in edit", this.userFields);

      if (this.instructorData.userId.userRole.includes('trainer') || this.instructorData.userId.userRole.includes('operative') || this.instructorData.userId.userRole.includes('mp') || this.instructorData.userId.userRole.includes('IQA') || this.instructorData.userId.userRole.includes('assetManager') || this.instructorData.userId.userRole.includes('manager') || !this.instructorData.userId.userRole.length) {
        this.isDisplay = true
        this.isDisableInstructor = true;
        this.longitude = this.instructorData && this.instructorData.locationDetails ? this.instructorData.locationDetails._id.locationGeometry.coordinates[0] : ''
        this.latitude = this.instructorData && this.instructorData.locationDetails ? this.instructorData.locationDetails._id.locationGeometry.coordinates[1] : ''
        this.what3words = this.instructorData && this.instructorData.locationDetails ? this.instructorData.locationDetails.what3words : ''
        if (this.instructorData && this.instructorData.locationDetails && this.instructorData.locationDetails._id) {
          this.isMapEdit = true
        } else {
          this.isMapEdit = false
        }
        this.createForm(this.instructorData, 'test3')
        this.userRoleSelection()
      } else {
        // this.isMapEdit = false

        this.activatedRoute.queryParams.subscribe(qparams => {
          console.log("params value", qparams);

          if (qparams && qparams.userRole && qparams.accidentType) {

            this.editAccidentDetails = {
              userRole: qparams.userRole,
              accidentType: qparams.accidentType,
              userId: qparams.userId,
              accidentId: qparams.accidentId,
              userForm: qparams.userForm,
            }

            this.isEdit = true
            this.isDisplay = false
            this.isDisableInstructor = false;
            this.isUserRole = false
            this.instructorData.userRole = qparams.userRole
            if (qparams.accidentType == 'goodPractice') {
              // this.selectedRole = 'reporter'
              this.accidentRole = [
                { key: 'Reporters', value: 'reporter' }]
              this.isDisable = true
            }
            this.isAccident = true
          } else {
            this.isDisplay = false
            this.isDisableInstructor = false;
            this.isUserRole = false
            this.isDisable = true
            this.isAccident = true
          }


          this.createForm1(this.instructorData)
        })
      }
    }
    this.loading = false
  }




  // FORM CONTROLL




  createForm(editData?, test?) {
    // if (editData && editData.locationDetails) {

    console.log("data while edit", editData, test, this.isMapEdit);
    // }

    this.editUserForm = this.formBuilder.group({
      name: new FormControl((editData && editData.name) ? editData.name : '', Validators.required),
      email: new FormControl((editData && editData.email) ? editData.email : '', Validators.email),
      mobile: new FormControl((editData && editData.mobile) ? editData.mobile : ''),
      // password: new FormControl((editData && editData.password) ? editData.password : '', Validators.required),
      password: new FormControl((editData && editData.password) ? editData.password : '', Validators.compose([
        Validators.required,
        this._policyService.patternValidator(/\d/, { hasNumber: true }),
        this._policyService.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
        Validators.minLength(8)
      ])),
      confirmPassword: new FormControl((editData && editData.confirmPassword) ? editData.confirmPassword : '', Validators.required),
      dateOfJoining: new FormControl((editData && editData.dateOfJoining) ? editData.dateOfJoining : '', Validators.required),
      role: new FormControl((editData && editData.userId) ? editData.userId.userRole : ''),
      sentinelNumber: new FormControl((editData && editData.sentinelNumber) ? editData.sentinelNumber : ''),
      insuranceNumber: new FormControl((editData && editData.insuranceNumber) ? editData.insuranceNumber : ''),
      points: new FormControl((editData && editData.details && editData.details.points) ? editData.details.points : ''),
      convictionList: this.formBuilder.array(this.multipleConvictions((editData && editData.details && editData.details.convictionList) ? editData.details.convictionList : [])),
      license: new FormControl((editData && editData.details && editData.details.license) ? editData.details.license : ''),
      selects: new FormControl((editData && editData.details && editData.details.selects) ? editData.details.selects : ''),
      userFields: new FormControl(''),
      jobLocation: new FormControl({ value: (editData && editData.locationDetails) ? editData.locationDetails.title : '', disabled: this.user && (this.user.isClient) ? true : false }),
      locationType: new FormControl('staff'),
      coordinates: new FormControl({ value: (editData && editData.locationDetails) ? editData.locationDetails._id.locationGeometry.coordinates : [], disabled: this.user && (this.user.isClient) ? true : false }),
      address: this.formBuilder.array(this.addresList((editData && editData.locationDetails) ? editData.locationDetails._id.address : [])),
      what3words: new FormControl({ value: (editData && editData.locationDetails) ? editData.locationDetails._id.what3words : '', disabled: this.user && (this.user.isClient) ? true : false }),
      jobRole: new FormControl((editData && editData.jobRole) ? editData.jobRole : ''),
      payRate: new FormControl((editData && editData.details && editData.details.payRate) ? editData.details.payRate : ''),
      payMethod: new FormControl((editData && editData.details && editData.details.payMethod) ? editData.details.payMethod : ''),
      midWeekRate: new FormControl((editData && editData.details && editData.details.midWeekRate) ? Number(editData.details.midWeekRate) : ''),
      weekendRate: new FormControl((editData && editData.details && editData.details.weekendRate) ? Number(editData.details.weekendRate) : ''),
      handBackRate: new FormControl((editData && editData.details && editData.details.handBackRate) ? Number(editData.details.handBackRate) : ''),
      otherRate: new FormControl((editData && editData.details && editData.details.otherRate) ? Number(editData.details.otherRate) : ''),
      // otherRate: new FormControl({ value: editData && editData.details && editData.details.otherRate ? Number(editData.details.otherRate) : Number(0)}),


      // payRate: new FormControl((editData && editData.details && editData.details.payRate) ? editData.details.payRate : ''),

      // userForm: new FormControl(''),
      // accidentUserRole: new FormControl((editData && editData.userRole) ? editData.userRole : '')
      // userFields: new FormControl(this.userFields)
    },
      {
        validator: this._policyService.passwordMatchValidator
      })
    console.log("what is the value of edit user form", this.editUserForm);
  }



  createForm1(editData?) {
    console.log("data while edit", editData);

    this.editUserForm = this.formBuilder.group({
      name: new FormControl((editData && editData.name) ? editData.name : '', Validators.required),
      email: new FormControl((editData && editData.email) ? editData.email : '', Validators.email),
      mobile: new FormControl((editData && editData.mobile) ? editData.mobile : ''),
      password: new FormControl((editData && editData.password) ? editData.password : '', Validators.compose([
        Validators.required,
        this._policyService.patternValidator(/\d/, { hasNumber: true }),
        this._policyService.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
        Validators.minLength(8)
      ])),
      // password: new FormControl((editData && editData.password) ? editData.password : '', Validators.required),
      confirmPassword: new FormControl((editData && editData.confirmPassword) ? editData.confirmPassword : '', Validators.required),
      userForm: new FormControl(''),
      accidentUserRole: new FormControl((editData && editData.userRole) ? editData.userRole : '')
    }, {
      validator: this._policyService.passwordMatchValidator
    })


  }





  // Get address list from formgroup
  getAddressList() {
    return this.editUserForm.get('address') as FormArray;
  }

  // Generate formarray for address list
  addresList(address) {
    console.log("ADDRESS LIST TO BE DISPLAY", address)
    if (address && address.length) {
      let locationArray = []
      _.forEach(address, async (singleLocation) => {
        await locationArray.push(new FormGroup({
          title: new FormControl({ value: (singleLocation && singleLocation.title) ? singleLocation.title : singleLocation.title, disabled: this.user && (this.user.isClient) ? true : false }),
        }))
      })
      return locationArray;
    } else {
      return [this.formBuilder.group({
        title: new FormControl('')
      })]
    }
  }



  setCurrentLocation(mapCurrentValue) {
    console.log("mapCurrentValue mapCurrentValue", mapCurrentValue, this.isMapEdit)
    // if (!this.isMapEdit) {
    this.latitude = mapCurrentValue.latitude
    this.longitude = mapCurrentValue.longitude
    this.address = mapCurrentValue.address
    let splitAddress = this.address.split(',')
    this.editUserForm.patchValue({
      coordinates: [this.longitude, this.latitude],
      jobLocation: this.address,
    })
    this.getAddressList().clear()
    this.updateAddressData(splitAddress)
    this.getWhat3words(this.latitude, this.longitude)
    // }
    console.log("AFTER SET THE LOCATION", this.editUserForm.value)
  }

  updateAddressData(address) {
    const control = this.getAddressList()
    address.forEach(element => {
      control.push(
        this.formBuilder.group({
          title: element
        })
      )
    });
  }


  // Generate What3words for selected location
  getWhat3words(latitude, longitude) {
    what3words.api.convertTo3waGeoJson({ lat: latitude, lng: longitude }, 'en').then((words) => {
      this.what3words = { what3wordsLink: words.features[0].properties.map, what3words: words.features[0].properties.words }
      // this._cd.detectChanges()
      this.editUserForm.patchValue({ what3words: { what3wordsLink: words.features[0].properties.map, what3words: words.features[0].properties.words } })
    })
    console.log("EDIT USER FORM DATA", this.editUserForm.value)
  }


  // Change location using drag and drop and update location
  changeLocation(location, inputIndex) {
    let element = []
    element.push(this.getAddressList().value.map((x) => { return x.title }))
    const address = this.getAddressList().value
    let singleAddress = address.map((x) => { return x.title }).join(',')
    console.log("VALUE OF EDIT STAFF PROFILE", this.editUserForm.value)
  }

  get multipleConvictionGroup() { return <FormArray>this.editUserForm.get('convictionList') }

  multipleConvictions(data?): Array<any> {


    if (data && data.length) {
      console.log("what is the data", data);

      const convictionList = []
      _.forEach(data, async (visit) => {
        await convictionList.push(new FormGroup({
          conviction: new FormControl(visit.conviction),
        }))
      })
      console.log("this is the final list to be send", convictionList);

      return convictionList;
    } else {
      return [this.formBuilder.group({
        conviction: new FormControl(''),
      })
      ]
    }

  }



  addConviction() {
    const control = <FormArray>this.editUserForm.controls.convictionList

    control.push(this.formBuilder.group({
      conviction: new FormControl(''),
    }))
  }



  deleteConviction(data, i) {
    console.log("what is in client", data);
    console.log("index value============", i);
    const control = <FormArray>this.editUserForm.controls.convictionList
    control.removeAt(i)
  }






  // UTILITY

  onChangeEvent(value, formControl) {
    console.log("value of date", value);
    console.log('formControl', formControl);
    if (formControl == 'dateOfJoining') {
      this.editUserForm.patchValue({ dateOfJoining: value })
    }
  }

  checkUserRole() {
    let userRole = this.editUserForm.get('role').value
    if (userRole.includes('trainer') || userRole.includes('operative')) return true
    else return false
  }


  selectedStatus(event, data) {
    console.log("what is the event", event);
    console.log("data to be send", data);
    if (data == 'isDrive' && event) {
      this.userFields[1].isDisplay = true
      this.userFields[2].isDisplay = true
    }
    if (data == 'isDrive' && !event) {
      this.userFields[1].isDisplay = false
      this.userFields[2].isDisplay = false
    }

    if (data == 'isMotoring' && event) {
      this.isConviction = true
    } else if (data == 'isMotoring' && !event) {
      this.isConviction = false
    }
  }


  onKeyPress(x) {
    this.clickMenuTrigger.openMenu();
    this.isPolicy = true
    // console.log("value of password", this.passwords);
  }
  closeModel() {
    this.clickMenuTrigger.closeMenu();
  }


  validate(data) {
    console.log("Validating ", data);
    if (!data.name) return false;
    if (!data.email) return false;
    if (!data.password) return false;
    // if (!data.dateOfJoining) return false;
    // if (!data.confirmPassword) return false;
    console.log('data here ==>', data)
    if (!data.role) return false;
    if (data.password !== data.confirmPassword) {
      console.log("Password Mismatch")
      this.passwordMismatch = true;
      return false;
    }
    this.passwordMismatch = false;
    return true;
  }

  roleChanged(event) {

    // console.log(this.data1[1].jobs);
    console.log('role changed', event.value);
    if (this.isDisableInstructor == false) {
      this.instructorData.userRole = event.value

    }
    else {
      this.instructorData.userId.userRole = event.value

    }
  }

  formChanged(event) {
    this.instructorData.userForm = event.value
  }

  formatDate(date) {
    console.log("what is date", date);

    let d = new Date(date);
    d.getFullYear() + "-" + d.getMonth() + "-" + d.getDate();
    console.log("this is d", d);

    return d
  }

  password() {
    this.show = !this.show;
    this.pwd = !this.pwd;
  }

  cpassword() {
    this.show1 = !this.show1;
    this.pwd1 = !this.pwd1
  }


  addFileModal() {


    let obj = {
      // userProfileDocs: true,
      uploadedBy: this.currentUser.name,
      staffId: this.instructorData._id
    }

    // if (this.materialId != undefined) {
    let addedCourse = this.openDialog(NewFileModalComponent, obj).subscribe((fileQueue) => {
      console.log("The queue recieved is", fileQueue);
      if (fileQueue == undefined || fileQueue.length == 0) return;

      _.forEach(fileQueue, (file) => {
        // if (this.files && this.files.length) {
        this.newFiles.push(file)
        console.log("new file-->", this.newFiles);
        // } else {
        //   this.files.push(file);
        //   console.log("file-->", this.files);
        // }
      })

    });
  }


  deleteFile(event, index) {
    this.files.splice(index, 1)
  }

  deleteNewFile(event, index) {
    this.newFiles.splice(index, 1)
  }




  userRoleSelection(event?) {
    let userRole = this.editUserForm.get('role').value
    console.log("what is the event", userRole);
    if (userRole.includes('trainer') || userRole.includes('operative')) this.isUserRole = true
    else this.isUserRole = false
  }


  // for image preview on edit click
  public addFile(event: any) {
    this.certFile = event.target.files;
    console.log('this.certFile', this.certFile);
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (event: any) => {
        this.url = event.target.result;
      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  public addProfileImage(event: any) {
    console.log("event", event);

    this.profileFile = event.target.files;
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (event: any) => {
        this.url1 = event.target.result;
      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data, width: '500px', height: '600px' });
    return dialogRef.afterClosed();
  }


  closoeDialog(result) {
    this.dialogRef.close(result);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }



  removeTrainerError() {
    this.openDialog(DeleteConfirmModalComponent, this.instructorTrainerJobs).subscribe(confirm => {
      console.log(confirm);
    });
    console.log("removeTrainerError");
  }
  removeMpError() {
    this.openDialog(DeleteConfirmModalComponent, this.instructorMpJobs).subscribe(confirm => {
      console.log(confirm);
    });
    console.log("removeMpError");
  }




  // API CALL

  doSubmit() {
    console.log("this.editUserForm.value----->", this.editUserForm.value)
    console.log("Submit ", this.data);
    console.log("this.instructorData", this.instructorData);
    let trainer: boolean = false
    let operative: boolean = false
    const data = new FormData();
    console.log("this.instructorData=========>>>>>>>>>", this.instructorData);

    _.forOwn(this.editUserForm.value, (value, key) => {
      console.log("this is value ", value);
      if (key == 'convictionList') {
        data.append(key, JSON.stringify(value))
      } else if (key == 'password') {
        console.log('this is key', key);
        const newPass = this._EncryptDecryptService.encrypt(value)
        data.append(key, newPass)
      }
      else if (key == 'confirmPassword') {
        console.log('this is key', key);
        const newPass = this._EncryptDecryptService.encrypt(value)
        data.append(key, newPass)
      }
      else if (key == 'role') {
        // let roleArray: any = []
        // roleArray.push(value.map((x) => { return x }))
        data.append(key, JSON.stringify(value))
      }
      else if (key == 'license') {
        data.append(key, JSON.stringify(value))
      } else if (key == 'coordinates' || key == 'address' || key == 'what3words') {
        data.append(key, JSON.stringify(value))
      }
      else {
        data.append(key, value)
      }
    });
    console.log("before push into main form", this.userFields);

    data.append('_id', this.instructorData._id)
    data.append('userFields', JSON.stringify(this.userFields))
    let policy = this.isPolicy

    // Profile Files Here
    if (this.profileFile.length) {
      for (let i = 0; i <= this.profileFile.length; i++) {
        data.append('profile', this.profileFile[i]);
      }
    }

    if (this.files && this.files.length && this.newFiles && this.newFiles.length) {
      console.log("hello here file edit data===>", this.files, this.newFiles)
      let mainArray = []
      let arrayLength = this.files.length;
      for (var i = 0; i < arrayLength; i++) {
        console.log(this.files[i]);
        //Do something
        mainArray.push(this.files[i]._id)
      }
      console.log("main file array value check here ==>", mainArray)
      data.append('userNewFiles', JSON.stringify(mainArray));
      data.append('userFiles', JSON.stringify(this.newFiles));

    }
    else if (this.newFiles && this.newFiles.length) {
      console.log('......../', this.newFiles)
      data.append('userFiles', JSON.stringify(this.newFiles));
      data.append('userNewFiles', JSON.stringify([]));

    }
    else if (this.newFiles && !this.files.length) {
      data.append('userFiles', JSON.stringify(this.newFiles));
      data.append('userNewFiles', JSON.stringify([]));
    }
    else {
      console.log("hello here file edit data=1111==>", this.files, this.newFiles)
      let mainArray = []
      let arrayLength = this.files.length;
      for (var i = 0; i < arrayLength; i++) {
        console.log(this.files[i]);
        //Do something
        mainArray.push(this.files[i]._id)
      }

      data.append('userFiles', JSON.stringify([]));

      data.append('userNewFiles', JSON.stringify(mainArray));
    }

    console.log("Validating = ", data);
    // if (!this.validate(this.instructorData)) {
    //   console.log("RETURNING");
    //   return;
    // }

    if (this.data && this.data.accidentUser == true || this.isAccident) {

      if (this.isAccident && !this.isEdit) {
        data.append('userId', this.instructorData._id)
        console.log("this is accident user only edit");
        this.updateAccidentUser(data)

      } else {
        if (this.isEdit) {




          // data.append('_id', this.data._id)
          data.append('userId', this.editAccidentDetails.userId)
          data.append('accidentId', this.editAccidentDetails.accidentId)
          data.append('onModel', 'accidentUser')
          // data['_id'] = 
          // data['userId'] =

          this.editAccidentUser(data)
        } else {
          data.append('accidentId', this.data.accidentId)
          this.newAccidentUser(data)
        }
      }
    } else {
      if (this.editUserForm.valid) {
        data.append('isPolicy', this.isPolicy)
        console.log("EDIT STAFF USER DATA", data)
        this.loading = true;
        console.log("data=======>", data);
        this._staffService.editInstructor(data).subscribe((data) => {
          console.log("this._staffService.editInstructor(data)", data);
          this.updatedInstructor.emit({ data })
          this.loading = false;
          this._utilityService.handleSnackBar({ msg: "User updated successfully!", button: "OK" })
          this.error = ''
          if (this.size != 0) {
            this.closoeDialog({
              action: 'edit',
              result: 'success',
              data: this.instructorData
            });
          }
        }, err => {
          this.loading = false;
          this.error = err.msg
        });
      } else {
        console.log("this is not validate", this.editUserForm.value);

        return
      }
    }
    // Do Submit
  }


  newAccidentUser(data) {
    console.log("new accident user add here ====>", data)
    this.loading = true
    this._userAccident.addAccidentUser(data).subscribe(accidentUser => {
      console.log('accident users data here =>', accidentUser)
      accidentUser['email'] = data.email
      accidentUser['mobile'] = data.mobile
      accidentUser['password'] = data.password
      this.loading = false
      this.closoeDialog(
        accidentUser
        // {
        // action: 'edit',
        // result: 'success',
        // data: accidentUser
        // }
      );
    }, (error) => {
      this.loading = false
      console.log('some thing wrong !!!', error)
      this.error = error.msg
    })
  }


  editAccidentUser(data) {
    console.log("data of edit accident user", data);
    this.loading = true
    this._userAccident.editAccidentUser(data).subscribe(accidentUser => {
      console.log('accident users data here =>', accidentUser)
      this.loading = false
      this.closoeDialog(
        accidentUser
        // {
        // action: 'edit',
        // result: 'success',
        // data: accidentUser
        // }
      );
    }, (error) => {
      this.loading = false
      console.log('some thing wrong !!!', error)
    })
  }


  updateAccidentUser(data) {
    this.loading = true
    this._userAccident.updateAccidentUser(data).subscribe(accidentUser => {
      console.log('accident users data here =>', accidentUser)
      this.loading = false
    }, (error) => {
      this.loading = false
      console.log('some thing wrong !!!', error)
    })
  }


  delete() {
    // console.warn("DELETING ", this.data._id);
    this.openDialog(DeleteConfirmModalComponent, "Member of Staff").subscribe(confirm => {
      if (confirm == '') return
      else if (confirm == 'yes') {
        this.loading = true;
        let userRole = this.instructorData.userId.userRole
        let obj = {
          userId: this.instructorData._id,
          userRole: userRole
        }
        this._staffService.deleteInstructor(JSON.stringify(obj)).subscribe(instructors => {
          console.log("instructores details", instructors);
          this.data = instructors;
          this.loading = false;
          // this.closoeDialog({
          //   action: 'delete',
          //   result: 'success',
          //   data: this.instructorData
          // });
          this.router.navigateByUrl('/users?currentTab=0')
        }, err => {
          console.log("error ", err);
          this.loading = false;
          this.deleteError = true
          this.deleteErrorMsg = err.msg
        });
      }
    })
  }

  fileDetails(event) {
    console.log("event ====", event);
    this.previousIndex = event.index
    let data = {}
    data['event'] = event;
    this._assetService.displayFile(data)
    // this.openFilesSideNav.emit({ event })
  }


  getJobRoleList() {
    this._staffService.getJobRoleList().subscribe((list) => {
      console.log("JOB ROLE LIST DATA", list)
      this.jobRoleList = list
    }, error => {
      console.log("ERROR WHILE JOB ROLE LIST", error)
    })
  }

  downloadSponsorpack() {

    this._staffService.downloadSponsorPack(this.instructorData._id, true).subscribe((res) => {
      console.log("RESPONSE OF DOWNLOAD", res)
      if (res) {
        const downloadLink = document.createElement("a");
        // const fileName = moment(new Date(obj.submissionDate)).format("MM-DD-YYYY") + ".pdf";
        downloadLink.href = res;
        // downloadLink.download = fileName;
        downloadLink.click();
        this._utilityService.handleSnackBar({ msg: "File downloaded successfully!", button: "Ok" })
      }
    }, err => {
      console.log("FIRST ERROR", err)
    })
  }

}
